module.exports = __webpack_public_path__ + "static/media/10.b620b05b.png";